import React from 'react'
import Feature_img01 from "../images/features-img-01.png"
import Feature_img02 from "../images/features-img-02.png"
import Feature_img03 from "../images/features-img-03.png"
import Feature_img04 from "../images/features-img-04.png"
import Feature_img05 from "../images/features-img-05.png"
import Feature_img06 from "../images/features-img-06.png"
import Feature_hov01 from "../images/features-hov-01.png"
import Feature_hov02 from "../images/features-hov-02.png"
import Feature_hov03 from "../images/features-hov-03.png"
import Feature_hov04 from "../images/features-hov-04.png"
import Feature_hov05 from "../images/features-hov-05.png"
import Feature_hov06 from "../images/features-hov-06.png"

export default function Features() {
  return (
    <div className='col-md-11 mx-auto'>
        <div className='row'>
            <div className='col-md-4 col-sm-6 mb-3'>
                <div className='features-box'>
                    <div className='features-img'>
                        <img src={Feature_img01} className='img-fluid' alt="" />
                        <img src={Feature_hov01} className='img-fluid' alt="" />
                    </div>
                    <div className='features-content'>
                        <h2 className='heading-title fw-600'>No Monthly Charges</h2>
                        <p>Tired of subscriptions? We hear you. ParcelX only charges you for your shipping. No extra No extra charges or subscription required.</p>
                    </div>
                </div>
            </div>
            <div className='col-md-4 col-sm-6 mb-3'>
                <div className='features-box'>
                    <div className='features-img'>
                        <img src={Feature_img02} className='img-fluid' alt="" />
                        <img src={Feature_hov02} className='img-fluid' alt="" />
                    </div>
                    <div className='features-content'>
                        <h2 className='heading-title fw-600'>No Fake Attempts</h2>
                        <p>ParcelX ensures genuine delivery with geo-tagged agents and prior contact sharing—no fake attempts, just reliable service.</p>
                    </div>
                </div>
            </div>
            <div className='col-md-4 col-sm-6 mb-3'>
                <div className='features-box'>
                    <div className='features-img'>
                        <img src={Feature_img03} className='img-fluid' alt="" />
                        <img src={Feature_hov03} className='img-fluid' alt="" />
                    </div>
                    <div className='features-content'>
                        <h2 className='heading-title fw-600'>Early COD Remittance</h2>
                        <p>We know how important money is. With timely COD remittance, you don’t have to wait for your money to come into your bank accounts.</p>
                    </div>
                </div>
            </div>
            <div className='col-md-4 col-sm-6 mb-3'>
                <div className='features-box'>
                    <div className='features-img'>
                        <img src={Feature_img04} className='img-fluid' alt="" />
                        <img src={Feature_hov04} className='img-fluid' alt="" />
                    </div>
                    <div className='features-content'>
                        <h2 className='heading-title fw-600'>Dedicated Account Manager</h2>
                        <p>We care about you. We give you your personal account manager to help resolve your queries anytime</p>
                    </div>
                </div>
            </div>
            <div className='col-md-4 col-sm-6 mb-3'>
                <div className='features-box'>
                    <div className='features-img'>
                        <img src={Feature_img05} className='img-fluid' alt="" />
                        <img src={Feature_hov05} className='img-fluid' alt="" />
                    </div>
                    <div className='features-content'>
                        <h2 className='heading-title fw-600'>Multiple Channel Integration</h2>
                        <p>Sync all your channels and marketplaces into a single dashboard for unified data access</p>
                    </div>
                </div>
            </div>
            <div className='col-md-4 col-sm-6 mb-3'>
                <div className='features-box'>
                    <div className='features-img'>
                        <img src={Feature_img06} className='img-fluid' alt="" />
                        <img src={Feature_hov06} className='img-fluid' alt="" />
                    </div>
                    <div className='features-content'>
                        <h2 className='heading-title fw-600'>Branded Tracking Page</h2>
                        <p>Sync all your channels and marketplaces into a single dashboard for unified data access</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
  )
}
